import * as types from 'models/actionTypes'

export const requestIkeaTokens = () => ({
    type: types.REQUEST_IKEA_TOKENS,
})

export const receiveIkeaTokens = (tokens) => ({
    type: types.RECEIVE_IKEA_TOKENS,
    tokens,
})
